<template>
    <div>
        <label class="mb-1">{{ $t('organization_details.public_documents') }}</label>
        <div class="md:flex-row flex flex-col">
            <div class="md:mr-3 flex-1 mb-3 mr-0">
                <div class="card input-border-color mb-0">
                    <div class="card-body lg:px-4 px-3">
                        <div class="flex flex-row items-center">
                            <div class="lg:mr-4 flex-1 mr-3">
                                <h4 class="mt-0 mb-1 text-base">{{ $t('organization_details.terms_and_conditions') }}</h4>
                                <div class="text-xs">
                                    {{ $t('globals.last_update', { date: formatDate(termsUpdatedAt) }) }}
                                </div>
                            </div>
                            <a class="btn btn-outline-primary btn-sm lg:mr-2 mr-1" href="/terms-and-conditions" target="_blank">
                                <span class="mr-1">{{ $t('organization_details.view') }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-1 mb-3">
                <div class="card input-border-color mb-0">
                    <div class="card-body lg:px-4 px-3">
                        <div class="flex flex-row items-center">
                            <div class="lg:mr-4 flex-1 mr-3">
                                <h4 class="mt-0 mb-1 text-base">{{ $t('organization_details.privacy_policy') }}</h4>
                                <div class="text-xs">
                                    {{ $t('globals.last_update', { date: formatDate(privacyUpdatedAt) }) }}
                                </div>
                            </div>
                            <a class="btn btn-outline-primary btn-sm lg:mr-2 mr-1" href="/privacy-policy" target="_blank">
                                <span class="mr-1">{{ $t('organization_details.view') }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="md:flex-row flex flex-col">
            <div class="md:mr-3 flex-1 mb-3 mr-0">
                <div class="card input-border-color mb-0">
                    <div class="card-body lg:px-4 px-3">
                        <div class="flex flex-row items-center">
                            <div class="lg:mr-4 flex-1 mr-3">
                                <h4 class="mt-0 mb-1 text-base">{{ $t('organization_details.suppliers_policy') }}</h4>
                                <div class="text-xs">
                                    {{ $t('globals.last_update', { date: formatDate(suppliersUpdatedAt) }) }}
                                </div>
                            </div>
                            <a class="btn btn-outline-primary btn-sm lg:mr-2 mr-1" href="/suppliers-policy" target="_blank">
                                <span class="mr-1">{{ $t('organization_details.view') }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-1 mb-3">
            </div>
        </div>
    </div>
</template>

<script>
import { lightFormat, parseISO } from 'date-fns';

export default {
    props: {
        termsUpdatedAt: {
            type: String,
            required: true,
        },
        privacyUpdatedAt: {
            type: String,
            required: true,
        },
        suppliersUpdatedAt: {
            type: String,
            required: true,
        },
    },

    methods: {
        formatDate(date) {
            return lightFormat(parseISO(date), 'dd-MM-y');
        },
    },
};
</script>
